import type { Locale } from '~/data/locales'

/**
 * 🌍 Gameplay CONTENT translations (v2.89) — relics and rewards.
 *
 * Kept separate from `locales.ts` (UI chrome) for two reasons. It is a
 * different surface with a different risk profile: a mistranslated menu
 * label is cosmetic, but a mistranslated relic description tells the
 * player the wrong thing about how the game WORKS. And it is keyed by
 * entity id rather than by screen, so it stays additive — the English
 * data files in `relics.ts` / `rewards.ts` remain the single source of
 * truth and are never touched.
 *
 * Key shape: `${kind}.${id}.${field}` — e.g. `relic.relic-sundial.name`.
 * Anything absent falls back to the English data file, so a partially
 * translated catalogue reads as mixed-language rather than broken.
 *
 * Translation notes:
 * - Game terms are translated consistently and NOT left in English:
 *   success chance → probabilidad de éxito / chances de réussite,
 *   XP → XP (kept, universally understood), gold → oro / or,
 *   Surge → Impulso / Poussée (matching `locales.ts`).
 * - Numbers, percentages and the +N formatting are preserved exactly,
 *   because they are what the player actually scans for.
 * - Spanish uses ¿…? and ¡…!; French uses a narrow no-break space (U+202F)
 *   before ? ! : and ; per typographic convention.
 *
 * NOT translated, deliberately: creature NAMES. They are proper nouns —
 * "Ember Cub", "Slagbeast" — and function as identity across the wiki,
 * the collection and player conversation. Their blurbs are flavour and
 * can be localised later; the names should be a deliberate call, not a
 * side effect. See the summary notes.
 */

export type ContentMap = Record<string, string>

/** 🌍 v6.63: LAZY, like the UI strings - app/data/lang/es-content.ts and
 * fr-content.ts are chunks registered here by plugins/locale.client.ts
 * (or useLocale.setLocale) for the player's language only. English needs
 * no entry: tc() falls back to the data files' own strings. */
export const CONTENT: Partial<Record<Exclude<Locale, 'en'>, ContentMap>> = {}
